import { noteKeys } from './keys';
import { queryClient } from './queryClient';
import type { BudgetNoteWorkspaceSnapshot } from '../utils/budgetNoteWorkspaceCache';
import {
  invalidateBudgetNoteWorkspaceCache as invalidateBudgetNoteWorkspaceLsCache,
} from '../utils/budgetNoteWorkspaceCache';
import type { TodoNoteWorkspaceSnapshot } from '../utils/todoNoteWorkspaceCache';
import {
  invalidateTodoNoteWorkspaceCache as invalidateTodoNoteWorkspaceLsCache,
  saveTodoNoteWorkspaceCache,
} from '../utils/todoNoteWorkspaceCache';
import {
  saveTodoNoteShareBridge,
  type TodoNoteShareBridge,
} from '../utils/todoNoteShareBridgeCache';
import { emitTodoNoteWorkspaceSaved } from '../utils/todoNoteWorkspaceSavedEvents';
import { patchTodoShareBoardContentSnapshot } from '../utils/todoShareBoardContentCache';

export function setTodoNoteWorkspaceQueryData(
  userId: string,
  noteWorkspaceId: string | null,
  snapshot: TodoNoteWorkspaceSnapshot
): void {
  if (!userId) return;
  queryClient.setQueryData(noteKeys.todoWorkspace(userId, noteWorkspaceId), snapshot);
}

/** Todo 노트(기본 보드) ↔ 대시보드 keep-alive 동기화. 추가 fetch 없음. */
export function publishTodoNoteWorkspaceSnapshot(
  userId: string,
  noteWorkspaceId: string | null,
  snapshot: TodoNoteWorkspaceSnapshot,
  bridge?: TodoNoteShareBridge
): void {
  if (!userId) return;
  saveTodoNoteWorkspaceCache(userId, noteWorkspaceId, snapshot);
  setTodoNoteWorkspaceQueryData(userId, noteWorkspaceId, snapshot);
  if (bridge) {
    saveTodoNoteShareBridge(userId, noteWorkspaceId, bridge);
    patchTodoShareBoardContentSnapshot(bridge.boardId, {
      revision: bridge.revision,
      categories: snapshot.categories,
      items: snapshot.items,
    });
  }
  emitTodoNoteWorkspaceSaved({
    userId,
    noteWorkspaceId,
    snapshot,
    boardId: bridge?.boardId,
  });
}

export function setBudgetNoteWorkspaceQueryData(
  userId: string,
  noteWorkspaceId: string | null,
  snapshot: BudgetNoteWorkspaceSnapshot
): void {
  if (!userId) return;
  queryClient.setQueryData(noteKeys.budgetWorkspace(userId, noteWorkspaceId), snapshot);
}

export function invalidateTodoNoteWorkspaceQuery(
  userId: string,
  noteWorkspaceId: string | null
): void {
  if (!userId) return;
  invalidateTodoNoteWorkspaceLsCache(userId, noteWorkspaceId);
  void queryClient.invalidateQueries({ queryKey: noteKeys.todoWorkspace(userId, noteWorkspaceId) });
}

export function invalidateBudgetNoteWorkspaceQuery(
  userId: string,
  noteWorkspaceId: string | null
): void {
  if (!userId) return;
  invalidateBudgetNoteWorkspaceLsCache(userId, noteWorkspaceId);
  void queryClient.invalidateQueries({ queryKey: noteKeys.budgetWorkspace(userId, noteWorkspaceId) });
}

export function removeAllNoteQueries(): void {
  queryClient.removeQueries({ queryKey: ['note'] });
}
